(function() {
	'use strict';

	var $ = avm.require('cash');
})();
